import { generateNumberSchema, generateRootObjectSchema, generateStringSchema } from "components/cards/common/schema";
import { BaseAtomSpec, generateAtomContainerSchema } from "components/cards/atoms/BaseAtomSpec";
import { ButtonParticleSpec, WebEmbedParticleSpec } from "components/cards/particles/YinzCam";


export const specification = new BaseAtomSpec("Web Embed Card", generateRootObjectSchema({
  container: generateAtomContainerSchema(),
  webEmbed: WebEmbedParticleSpec.generateSchema("Web Embed", "", { defaultValues: { container: { fillWidth: true, fillHeight: true }, noDefaultStyling: true } }),
}));
